import { TableCell, TableContainer } from '@material-ui/core';
import styled, { css } from 'styled-components';

import { Form } from '~/components/Form';

export const WrapperContainer = styled(TableContainer)`
  height: ${({ maxHeight }) => maxHeight};
  max-height: 100%;

  position: relative;

  .MuiTableRow-root.Mui-selected,
  .MuiTableRow-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.01) !important;
    box-shadow: 0px 3px 5px 0px rgb(0 0 0 / 30%);
  }

  tbody.MuiTableBody-root tr:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.015);
  }
`;

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  th .MuiSelect-select {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const Cell = styled(TableCell)`
  ${(props) =>
    props.nowrap === 1
      ? css`
          max-width: 15ch;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `
      : ``}
`;

export const GroupButtons = styled.div`
  position: absolute;
  right: ${({ isLeft }) => `-${isLeft}px`};

  margin-top: -0.5rem;

  display: ${({ show }) => (show === 0 ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;

  padding: 0.4rem 1.5rem;

  background: rgba(255, 255, 255, 0.9);

  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  button {
    padding: 0;

    svg {
      font-size: 2rem;
    }

    + button {
      margin-left: 1.5rem;
    }

    &:hover {
      color: #3f51b5;
    }
  }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 1.5rem;
`;

export const ToolbarActions = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button + button {
    margin-left: 1rem;
  }
`;

export const WrapperDrawer = styled.div`
  width: 300px;

  padding: 1.5rem;

  display: flex;
  align-items: center;
  flex-direction: column;

  flex: 1;

  > div {
    margin-bottom: 1.5rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const WrapperFilters = styled.div`
  display: flex;
  flex-direction: column;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }

  .MuiFormHelperText-root {
    margin-top: 0 !important;
    color: red !important;
  }
`;
export const GroupButtonsDrawer = styled.div`
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.5rem;
`;

export const WrapperPagination = styled.div`
  margin-top: 0.5rem;

  display: flex;
  align-items: center;
  justify-content: center;
`;
